import { checkURLReg } from '../config/Global';
import Message from '../config/Message';

export const LoginRequest = {
	success: 'Login Successfull.',
	userName: [
		{ required: true, message: Message().required.text('User name') },
	],
	password: [
		{ required: true, message: Message().required.text('Password') },
	],
};

export const DashboardRequest = {
	title: [{ required: true, message: Message().required.text('Title') }],
	description: [
		{ required: true, message: Message().required.text('description') },
	],
	price: [
		{ required: true, message: Message().required.text('price') },
		{ pattern: /^[1-9\b]+$/, message: 'Only digit allow' },
	],
	percentage_discount: [
		{
			required: true,
			message: Message().required.text('Percentage Discount'),
		},
		{ pattern: /^[1-9\b]+$/, message: 'Only digit allow' },
	],
	in_stock: [
		{ required: true, message: Message().required.text('In Stock') },
		{ pattern: /^[1-9\b]+$/, message: 'Only digit allow' },
	],
};

export const AdminUserRequest = {
	firstName: [
		{ required: true, message: Message().required.text('First name') },
		{
			pattern: /^[A-Za-z\s]+$/,
			message: Message().regex.other('First name'),
		},
		{ min: 3, message: Message().min.string(3, 'First name') },
		{ max: 20, message: Message().max.string(20, 'First name') },
	],
	lastName: [
		{ required: true, message: Message().required.text('Last name') },
		{ min: 3, message: Message().min.string(3, 'Last name') },
		{
			pattern: /^[A-Za-z\s]+$/,
			message: Message().regex.other('Last name'),
		},
		{ max: 20, message: Message().max.string(20, 'Last name') },
	],
	email: [
		{ required: true, message: Message().required.text('Email') },
		{
			pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
			message: Message().email('This'),
		},
		{ min: 3, message: Message().min.string(3, 'Email') },
		{ max: 50, message: Message().max.string(50, 'Email') },
	],
	mobileNo: [
		{ required: true, message: Message().required.text('Mobile no.') },
		{
			pattern: /^[1-9]\d{9}$/,
			message: Message().regex.other('Mobile no'),
		},
	],
	userName: [
		{ required: true, message: Message().required.text('User Name') },
		{ min: 3, message: Message().min.string(3, 'User Name') },
		{ max: 20, message: Message().max.string(20, 'User Name') },
	],
	role: [{ required: true, message: Message().required.text('Role') }],
	password: [
		{
			required: true,
			message: Message().required.text('Password'),
		},
		{
			pattern: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
			message: Message().regex.password('Password'),
		},
	],
	cn_password: [
		{
			required: true,
			message: Message().required.text('Confirm Password'),
		},
		({ getFieldValue }) => ({
			validator(_, value) {
				if (!value || getFieldValue('password') === value) {
					return Promise.resolve();
				}
				return Promise.reject(
					new Error('The new password that you entered do not match!')
				);
			},
		}),
	],
};
export const AdminSettingsRequest = {
	settingKey: [
		{ required: true, message: Message().required.text('Setting key') },
		{
			pattern: /^[^\s]+$/,
			message: Message().regex.other('Setting Key'),
		},
		{ min: 2, message: Message().min.string(2, 'Setting Key') },
		{ max: 50, message: Message().max.string(50, 'Setting Key') },
	],
	settingName: [
		{ required: true, message: Message().required.text('Setting name') },
		{
			pattern: /^[A-Za-z][A-Za-z\s]*$/,
			message: Message().regex.other('Setting Name'),
		},
		{ min: 3, message: Message().min.string(3, 'Setting Name') },
		{ max: 50, message: Message().max.string(20, 'Setting Name') },
	],
	settingValue: [
		{ required: true, message: Message().required.text('Setting value') },
		{
			pattern: /^[^\s]+$/,
			message: Message().regex.other('Setting Value'),
		},
		{ min: 2, message: Message().min.string(2, 'Setting Value') },
		{ max: 200, message: Message().max.string(200, 'Setting Value') },
	],
	settingdbType: [
		{ required: true, message: Message().required.text('Setting DB') },
		{ pattern: /^\d+$/, message: Message().regex.other('Setting DB') },
		{ min: 1, message: Message().min.string(1, 'Setting DB') },
		{ max: 3, message: Message().max.string(3, 'Setting DB') },
	],
};

export const MerchantRequest = {
	merchantName: [
		{ required: true, message: Message().required.text('Merchant Name') },
		{
			pattern: /^[A-Za-z\s]+$/,
			message: Message().regex.other('Merchant Name'),
		},
		{ min: 3, message: Message().min.string(3, 'Merchant Name') },
		{ max: 20, message: Message().max.string(20, 'Merchant Name') },
	],
	shortName: [
		{ required: true, message: Message().required.text('Short Name') },
		{
			pattern: /^[a-z-]*$/,
			message: Message().regex.other('Short Name'),
		},
		{ min: 3, message: Message().min.string(3, 'Short Name') },
		{ max: 20, message: Message().max.string(20, 'Short Name') },
	],
	email: [
		//{ required: true, message: Message().required.text('Email') },
		{
			pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
			message: Message().email('This'),
		},
		{ min: 3, message: Message().min.string(3, 'Email') },
		{ max: 50, message: Message().max.string(50, 'Email') },
	],
	phoneNo: [
		{ required: true, message: Message().required.text('Phone Number') },
		{
			pattern: /^[1-9]\d{9}$/,
			message: Message().regex.other('Phone Number'),
		},
	],
	// description: [
	// 	{
	// 		pattern: /^(?:.*\S.*\S.*\S.*)$/,
	// 		min: 3,
	// 		message: Message().min.string(3, 'Description'),
	// 	},
	// 	//{ max: 500, message: Message().max.string(500, 'Description') },
	// ],
	state: [{ required: true, message: Message().required.text('State') }],
	city: [{ required: true, message: Message().required.text('City') }],
	pinCode: [
		{
			pattern: /^\d{6}$/,
			message: Message().regex.other('Pin code'),
		},
	],
	URL: [
		{
			pattern: checkURLReg,
			message: Message().regex.other('URL'),
		},
	],
	isLiveDarshan: [
		{ required: true, message: Message().required.text('Live Darshan') },
		{
			pattern: checkURLReg,
			message: Message().regex.other('URL'),
		},
	],
	merchantDatabase: [
		{
			pattern: /^[A-Za-z\s]+$/,
			message: Message().regex.other('Merchant Database'),
		},
		{ min: 3, message: Message().min.string(3, 'Merchant Database') },
		{ max: 20, message: Message().max.string(20, 'Merchant Database') },
	],
	address: [
		{ required: true, message: Message().required.text('Address') },
		{ min: 10, message: Message().min.string(10, 'Address') },
	],
	merchantRole: [
		{ required: true, message: Message().required.select('Merchant Role') },
	],
	gst: [
		{
			pattern:
				/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
			message: Message().regex.other('GST Number'),
		},
	],
	pan: [
		{
			pattern: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
			message: Message().regex.other('PAN Number'),
		},
	],
};

export const templeRequest = {
	templeName: [
		{ required: true, message: Message().required.text('Temple name') },
		{
			pattern: /^[A-Za-z\s]+$/,
			message: Message().regex.other('Temple name'),
		},
		{ min: 3, message: Message().min.string(3, 'Temple name') },
		{ max: 100, message: Message().max.string(100, 'Temple name') },
	],
	shortName: [
		{ required: true, message: Message().required.text('Short Name') },
		{
			pattern: /^[a-zA-Z-]*$/,
			message: Message().regex.other('Short Name'),
		},
		{ max: 20, message: Message().max.string(20, 'Short Name') },
	],
	metaKeywords: [
		{ required: true, message: Message().required.text('Meta Keywords') },
	],
	metaTitle: [
		{ required: true, message: Message().required.text('Meta Keywords') },
	],
	seoTitle: [
		{ max: 500, message: Message().max.string(500, 'SEO Title') },
	],
	metaDescription: [
		{
			required: true,
			message: Message().required.text('Meta Description'),
		},
		{ min: 3, message: Message().min.string(3, 'Meta Description') },
		// { max: 50, message: Message().max.string(50, 'Meta Description') },
	],
	howtoReach: [
		{ required: true, message: Message().required.text('How to Reach') },
		{ min: 3, message: Message().min.string(3, 'How to Reach') },
		{ max: 1000, message: Message().max.string(1000, 'How to Reach') },
	],
	nearbyPlaces: [
		{ required: true, message: Message().required.text('Nearby Places') },
		{ min: 3, message: Message().min.string(3, 'Nearby Places') },
		{ max: 1000, message: Message().max.string(1000, 'Nearby Places') },
	],
	bestTimeToVisit: [
		{
			required: true,
			message: Message().required.text('Best Time to Visit'),
		},
		{ min: 3, message: Message().min.string(3, 'Best Time to Visit') },
		{ max: 500, message: Message().max.string(500, 'Best Time to Visit') },
	],
	remarks: [
		{ min: 3, message: Message().min.string(3, 'Remarks') },
		// { max: 500, message: Message().max.string(500, 'Remarks') },
	],
	darshanType: [
		{ required: true, message: Message().required.text('Darshan Type') },
	],
	darshanTime: [
		{ required: true, message: Message().required.text('Darshan Time') },
	],
	popularity: [
		{ required: true, message: Message().required.text('Popularity') },
	],
	imageType: [
		{ required: true, message: Message().required.text('Image Type') },
	],
	imgDescription: [
		{
			required: true,
			message: Message().required.text('Image Description'),
		},
		{ min: 3, message: Message().min.string(3, 'Image Description') },
		{ max: 50, message: Message().max.string(50, 'Image Description') },
	],
	description: [
		{
			required: true,
			message: Message().required.text('Description'),
		},
		{
			min: 3,
			message: Message().min.string(3, 'Description'),
		},
	],
	CTAText: [
		{ min: 3, message: Message().min.string(3, 'CTA') },
	],
	faqQuestion: [
		{
			required: true,
			message: Message().required.text('Question'),
		},
		{
			min: 3,
			message: Message().min.string(3, 'Question'),
		},
	],
	faqAnswer: [
		{
			required: true,
			message: Message().required.text('Answer'),
		},
		{
			min: 3,
			message: Message().min.string(3, 'Answer'),
		},
	],
	faQsSchema: [
		{
			required: false,
		},
	],
};

export const accommodationRequest = {
	roomType: [
		{ required: true, message: Message().required.text('Room Type') },
	],
	propertyType: [
		{ required: true, message: Message().required.text('Property Type') },
	],
	TDSType: [
		{ required: true, message: Message().required.text('TDS Type') },
	],
	// time: [{ required: true, message: Message().required.text('Time') }],
	checkIn: [
		{ required: true, message: Message().required.text('Check In.') },
	],
	checkOut: [
		{ required: true, message: Message().required.text('Check Out.') },
	],
	roomTitle: [
		{ required: true, message: Message().required.text('Room Title') },
		{ max: 50, message: Message().max.string(50, 'Room Title') },
	],
	noofBed: [
		{
			required: true,
			message: Message().required.text('No Of Bed'),
		},
		{
			pattern: /^\d+$/,
			message: Message().regex.other('No Of Bed'),
		},
	],
	additionalBedCapacity: [
		{
			required: true,
			message: Message().required.text('Additional Capacity'),
		},
		{
			pattern: /^\d+$/,
			message: Message().regex.other('Additional Capacity'),
		},
	],
	noofBathroom: [
		{
			required: true,
			message: Message().required.text('No of Bathroom'),
		},
		{
			pattern: /^\d+$/,
			message: Message().regex.other('No of Bathroom'),
		},
	],
	maxGuest: [
		{
			required: true,
			message: Message().required.text('Maximum Guest'),
		},
		{
			pattern: /^\d+$/,
			message: Message().regex.other('Maximum Guest'),
		},
	],
	noofRoom: [
		{
			required: true,
			message: Message().required.text('No of Room'),
		},
		{
			pattern: /^\d+$/,
			message: Message().regex.other('No of Room'),
		},
	],
	amenity: [
		{ required: true, message: Message().required.text('Amenity Type') },
	],
	subscription: [
		{
			required: true,
			message: Message().required.text('Subscription Type'),
		},
	],
	propertyName: [
		{ required: true, message: Message().required.text('Property Name') },
	],
	address: [
		{ required: true, message: Message().required.text('Address') },
		{ min: 10, message: Message().min.string(10, 'Address') },
	],
	state: [{ required: true, message: Message().required.text('State') }],
	city: [{ required: true, message: Message().required.text('City') }],
	pinCode: [
		//{ required: true, message: Message().required.text('Pin Code') },
		{
			pattern: /^\d{6}$/,
			message: Message().regex.other('Pin code'),
		},
	],
	contactNo: [
		{ required: true, message: Message().required.text('Phone Number') },
		{
			pattern: /^[1-9]\d{9}$/,
			message: Message().regex.other('Phone Number'),
		},
	],
	PANNo: [
		({ getFieldValue }) => ({
			validator(_, value) {
				const tdsCategory = getFieldValue('tdsCategory');
				const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
				if ([1, 2].includes(tdsCategory)) {
					if (!value) {
						return Promise.reject(new Error('PAN number is required.'));
					}
					if (!panRegex.test(value)) {
						return Promise.reject(new Error('PAN number that you entered is not valid!'));
					}
					return Promise.resolve();
				}
				if (value && !panRegex.test(value)) {
					return Promise.reject(new Error('PAN number that you entered is not valid!'));
				}
				return Promise.resolve();
			},
		})
	],
	// description: [
	// 	{
	// 		pattern: /^(?:.*\S.*\S.*\S.*)$/,
	// 		min: 3,
	// 		message: Message().min.string(3, 'Description'),
	// 	},
	// 	//{ max: 500, message: Message().max.string(500, 'Description') },
	// ],
	merchantName: [
		{ required: true, message: Message().required.text('Merchant Name') },
	],
	imageType: [
		{ required: true, message: Message().required.text('Image Type') },
	],
	roomCategoryLookup: [
		{ required: true, message: Message().required.text('Room Category') },
	],
	imgDescription: [
		{
			required: true,
			message: Message().required.text('Image Description'),
		},
		{ min: 3, message: Message().min.string(3, 'Image Description') },
		{ max: 50, message: Message().max.string(50, 'Image Description') },
	],
	rating: [
		// { required: true, message: Message().required.text('Rating') },
		{
			pattern: /^[0-5]$/,
			message: 'Rating must be an integer between 0 and 5.',
		},
	],
	roomSize: [
		// {
		// 	required: true,
		// 	message: Message().required.text('Room Size'),
		// },
		// {
		// 	pattern: /^\d+$/,
		// 	message: Message().regex.other('Number'),
		// },
		// {
		// 	pattern: /^(?:[1-9]|[1-4][0-9]|50)$/,
		// 	message: 'Room Size must be an integer 50.',
		// },
		{ max: 50, message: Message().max.string(50, 'Room Size') },
	],
	metaKeywords: [
		{ required: true, message: Message().required.text('Meta keywords') },
	],
	metaTitle: [
		{ required: true, message: Message().required.text('Meta title') },
	],
	seoTitle: [
		{ max: 500, message: Message().max.string(500, 'SEO Title') },
	],
	faQsSchema: [
		{
			required: false,
		},
	],
	metaDescription: [
		{
			required: true,
			message: Message().required.text('Meta description'),
		},
		{ min: 3, message: Message().min.string(3, 'Meta description') },
	],
	shortName: [
		{
			required: true,
			message: Message().required.text('Short Name'),
		},
		{
			pattern: /^[a-zA-Z-]*$/,
			message: Message().regex.other('Short Name'),
		},
	],
};

export const regionRequest = {
	regionType: [
		{
			required: true,
			message: Message().required.text('Region Type'),
		},
	],
	EParentRegionId: [
		{
			required: true,
			message: Message().required.text('Parent Region'),
		},
	],
	regionCode: [
		{
			required: true,
			message: Message().required.text('Region Code'),
		},
		{
			pattern: /^\d+$/,
			message: Message().regex.other('Region Code'),
		},
	],
	regionName: [
		{
			required: true,
			message: Message().required.text('Region Name'),
		},
		{
			pattern: /^[A-Za-z\s]+$/,
			message: 'Region Name must only contain alphabetic characters',
		},
	],
	metaTitle: [
		// {
		// 	pattern: /^[A-Za-z\s.,"]+$/,
		// 	message: 'Meta Title Name must only contain alphabetic characters',
		// },
		{ max: 500, message: Message().max.string(500, 'Meta Title') },
	],
	metaDescription: [
		// {
		// 	pattern: /^[A-Za-z\s.,"]+$/,
		// 	message: 'Meta Description Name must only contain alphabetic characters',
		// },
		{ max: 500, message: Message().max.string(500, 'Meta Description') },
	],
	metaKeyword: [
		// {
		// 	pattern: /^[A-Za-z\s.,"]+$/,
		// 	message: 'Meta Keyword Name must only contain alphabetic characters',
		// },
		{ max: 500, message: Message().max.string(500, 'Meta Keyword') },
	],
	templeSEOTitle: [
		{ max: 500, message: Message().max.string(500, 'Temple SEO Title') },
	],
	propertySEOTitle: [
		{ max: 500, message: Message().max.string(500, 'Property SEO Title') },
	]
};
export const publicSettingRequest = {
	settingKey: [
		{ required: true, message: Message().required.text('Setting key') },
		{
			pattern: /^[^\s]+$/,
			message: Message().regex.other('Setting Key'),
		},
		{ min: 2, message: Message().min.string(2, 'Setting Key') },
		{ max: 50, message: Message().max.string(50, 'Setting Key') },
	],
	settingName: [
		{ required: true, message: Message().required.text('Setting name') },
		{
			pattern: /^[A-Za-z][A-Za-z\s]*$/,
			message: Message().regex.other('Setting Name'),
		},
		{ min: 3, message: Message().min.string(3, 'Setting Name') },
		{ max: 50, message: Message().max.string(20, 'Setting Name') },
	],
	settingValue: [
		{ required: true, message: Message().required.text('Setting Value') },
		{ min: 2, message: Message().min.string(2, 'Setting Value') },
	],
	settingdbType: [
		{ pattern: /^\d+$/, message: Message().regex.other('Setting DB') },
		{ min: 1, message: Message().min.string(1, 'Setting DB') },
		{ max: 3, message: Message().max.string(3, 'Setting DB') },
	],
};
export const TourPackageCategoryRequest = {
	name: [
		{ required: true, message: Message().required.text('name') },
		{
			pattern: /^[A-Za-z\s]+$/,
			message: 'Category Name must only contain alphabetic characters',
		},
		{ min: 3, message: Message().min.string(3, 'Category Name') },
		{ max: 100, message: Message().max.string(100, 'Category Name') },
	],
	sortOrder: [
		{ required: true, message: Message().required.text('Sort Order') },
		{ pattern: /^[0-9\b]+$/, message: 'Only digit allow' },
	],
};
export const enquiryRequest = {
	enquiryType: [
		{ required: true, message: Message().required.text('Enquiry Type') },
	],
	name: [
		{ required: true, message: Message().required.text('Name') },
		{
			pattern: /^[A-Za-z][A-Za-z\s]*$/,
			message: Message().regex.other('Name'),
		},
		{ min: 3, message: Message().min.string(3, 'Name') },
		{ max: 50, message: Message().max.string(20, 'Name') },
	],
	mobileNumber: [
		{ required: true, message: Message().required.text('Mobile Number') },
		{
			pattern: /^[1-9]\d{9}$/,
			message: Message().regex.other('Mobile Number'),
		},
	],
	email: [
		{
			pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
			message: Message().email('This'),
		},
		{ min: 3, message: Message().min.string(3, 'Email') },
		{ max: 50, message: Message().max.string(50, 'Email') }
	],
	description: [
		{ required: true, message: Message().required.text('Description') },
		{
			pattern: /^[A-Za-z][A-Za-z\s]*$/,
			message: Message().regex.other('Description'),
		},
		{ min: 3, message: Message().min.string(3, 'Description') },
		{ max: 50, message: Message().max.string(20, 'Description') },
	],
	enquiryStatus: [
		{ required: true, message: Message().required.text('Enquiry Status') },
	],
};
